import React, { useRef, useMemo, useState } from 'react';
import { Form, Input, Select, Button, Checkbox, Radio, message } from 'antd';
import { observer } from 'mobx-react-lite';
import Countdown from '@/components/chat-history/plan-question/countdown';
import gaokaoStore from './store';
import './index.scss';
import { useEffect } from 'react';

const { Option } = Select;

const GaoKaoParams = props => {
  const { event, messageItem, cid, isAITyping, handleSend, mcpStore, planed } =
    props;

  const { conversation_id, msg_id, detail, planStepId } = event || {};
  const { gaokao_intention } = detail || {};

  // 选项数据
  const priorityOptions = ['学校优先', '专业优先'];
  const graduationOptions = ['就业', '考研', '出国', '创业'];
  const [step, setStep] = useState(1);
  const [disable, setDisable] = useState(planed);

  const requiredParam = useRef({
    score: '',
    province: '',
    subjects: [],
    bakSubjects: [],
  });
  const optionalParam = useRef({
    preferredCity: '',
    major: [],
    graduation: [],
  });

  const [form] = Form.useForm();

  const onRequiredFinish = async values => {
    const formData = {
      score: gaokaoStore.score || values.score || '',
      province: gaokaoStore.selectedProvince || values.province || '',
      subjects: gaokaoStore.selectedSubjects || values.subjects || [],
      bak_subjects: gaokaoStore.selectedBakSubjects || values.bakSubjects || [],
      pici: gaokaoStore.selectedPici || values.pici || '',
      priority: gaokaoStore.selectedPriority || values.priority || '',

      preferred_city:
        gaokaoStore.selectedPreferredCity || values.preferredCity || '',
      classify: gaokaoStore.selectedClassify || values.classify || '',
      major: gaokaoStore.selectedMajor || values.major || [],
      graduation: gaokaoStore.selectedGraduations || values.graduation || [],
    };

    try {
      const params = {
        cid: conversation_id,
        msg_id,
        plan_step_id: planStepId,
        data: {
          gaokao_intention: {
            ...gaokao_intention,
            ...formData,
          }
        },
      };
      await gaokaoStore.patchData(params);
      handleSend({
        ctx_extra_id: [msg_id],
      });
    } catch (error) {
      console.error('提交高考数据失败:', error);
      message.error('提交高考数据失败，请稍后重试');
    }
    setStep(2); // 提交后进入下一步
  };

  const onRequiredFinishFailed = errorInfo => {
    console.log('提交失败:', errorInfo);
    message.error('请检查表单填写是否正确');
  };

  const toggleSubject = subject => {
    if (
      !gaokaoStore.isSelectedSubject(subject) &&
      gaokaoStore.selectedSubjects.length >= 3
    ) {
      message.error('最多只能选择3个科目');
      return;
    }
    gaokaoStore.toggleSubject(subject);
  };

  const toggleBakSubject = subject => {
    if (
      !gaokaoStore.isSelectedBakSubject(subject) &&
      gaokaoStore.selectedBakSubjects.length >= 3
    ) {
      message.error('最多只能选择3个科目');
      return;
    }
    gaokaoStore.toggleBakSubject(subject);
  };

  const togglePici = pici => {
    if (gaokaoStore.selectedPici === pici) {
      gaokaoStore.setPici(''); // 如果已选中则取消选择
    } else {
      gaokaoStore.setPici(pici);
    }
  };

  const togglePriority = priority => {
    if (gaokaoStore.selectedPriority === priority) {
      gaokaoStore.setPriority(''); // 如果已选中则取消选择
    } else {
      gaokaoStore.setPriority(priority);
    }
  };

  const toggleGraduation = graduation => {
    if (gaokaoStore.isSelectedGraduation(graduation)) {
      gaokaoStore.removeGraduation(graduation);
    } else {
      gaokaoStore.addGraduation(graduation);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      gaokao_intention?.province &&
        gaokaoStore.setProvince(gaokao_intention?.province);
      gaokao_intention?.score && gaokaoStore.setScore(gaokao_intention?.score);
      gaokao_intention?.classify &&
        gaokaoStore.setClassify(gaokao_intention?.classify);
      gaokao_intention?.subjects &&
        gaokaoStore.setSubjects(gaokao_intention?.subjects);
    }, 50);
  }, [gaokao_intention]);

  useEffect(() => {
    // 初始化省份和科目
    form.setFieldsValue({
      province: gaokaoStore.selectedProvince || '',
      score: gaokaoStore.score || '',
      subjects: [...gaokaoStore.selectedSubjects],
      bakSubjects: [...gaokaoStore.selectedBakSubjects],
      pici: gaokaoStore.selectedPici || '',
      priority: gaokaoStore.selectedPriority || '',
      preferredCity: gaokaoStore.selectedPreferredCity || '',
      major: [...gaokaoStore.selectedMajor],
      graduation: [...gaokaoStore.selectedGraduations],
    });
  }, [
    gaokaoStore.selectedProvince,
    gaokaoStore.score,
    gaokaoStore.selectedSubjects,
    gaokaoStore.selectedBakSubjects,
    gaokaoStore.selectedPici,
    gaokaoStore.selectedPriority,
    gaokaoStore.selectedPreferredCity,
    gaokaoStore.selectedMajor,
    gaokaoStore.selectedGraduations,
  ]);

  /**
   * 与所选省份相关的科目
   */
  const refSubject = useMemo(() => {
    console.log('当前选中的省份:', gaokaoStore.selectedProvince);
    return gaokaoStore.getSubjects();
  }, [gaokaoStore.selectedProvince]);

  /**
   * 与所选省份相关的科目
   */
  const refPici = useMemo(() => {
    return gaokaoStore.getPicies();
  }, [gaokaoStore.selectedProvince]);

  const refMajor = useMemo(() => {
    console.log('当前选中的学科:', gaokaoStore.selectedDiscipline);
    const classifies = gaokaoStore.getDisciplines();
    if (
      !gaokaoStore.selectedDiscipline ||
      !classifies[gaokaoStore.selectedDiscipline]
    ) {
      return [];
    }
    return classifies[gaokaoStore.selectedDiscipline] || [];
  }, [gaokaoStore.selectedDiscipline]);

  const disciplineOptions = useMemo(() => {
    return Object.keys(gaokaoStore.getDisciplines());
  }, []);

  const renderRequiredInfo = () => {
    return (
      <div className="relative">
        <Form
          form={form}
          layout="horizontal"
          onFinish={onRequiredFinish}
          onFinishFailed={onRequiredFinishFailed}
          initialValues={{
            score: gaokaoStore.score || '',
            province: gaokaoStore.selectedProvince || '',
            subjects: [...gaokaoStore.selectedSubjects],
            bakSubjects: [...gaokaoStore.selectedBakSubjects],
            pici: gaokaoStore.selectedPici || '',
            priority: gaokaoStore.selectedPriority || '',
            preferredCity: gaokaoStore.selectedPreferredCity || '',
            major: gaokaoStore.selectedMajor || [],
            graduation: gaokaoStore.selectedGraduations || [],
          }}
          disabled={step !== 1}
        >
          <Form.Item
            label="高考所在地："
            name={'province'}
            rules={[{ required: true, message: '请选择高考所在地' }]}
          >
            <Select
              placeholder="请选择高考所在地"
              value={gaokaoStore.selectedProvince}
              onChange={value => gaokaoStore.setProvince(value)}
            >
              {gaokaoStore.provinces.map(item => (
                <Option key={item} value={item}>
                  {item}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            label="分数"
            name="score"
            rules={[
              { required: true, message: '请输入高考分数' },
              {
                pattern: /^\d{1,3}(\.\d{1})?$/,
                message: '请输入有效分数 (如: 660.5)',
              },
              {
                validator: (_, value) => {
                  const score = parseFloat(value);
                  if (score > 750) {
                    return Promise.reject('分数不能超过750分');
                  }
                  return Promise.resolve();
                },
              },
            ]}
          >
            <Input
              placeholder="请输入高考分数 (如: 660.5)"
              value={gaokaoStore.score}
              onChange={e => gaokaoStore.setScore(e.target.value)}
              autoComplete="off"
            />
          </Form.Item>

          <Form.Item
            label={`${refSubject.title1}（必选${refSubject.firstCount}项）`}
            required
            name="subjects"
            validateStatus={
              gaokaoStore.selectedSubjects.length !== refSubject.firstCount
                ? 'error'
                : ''
            }
            help={
              gaokaoStore.selectedSubjects.length !== refSubject.firstCount
                ? `请选择${refSubject.firstCount}个科目`
                : ''
            }
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
          >
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(3, 1fr)', // 每行3列
                gap: 16,
                alignItems: 'center',
              }}
            >
              {refSubject.name.map((subject, index) => (
                <Checkbox
                  key={subject}
                  checked={gaokaoStore.isSelectedSubject(subject)}
                  onChange={() => toggleSubject(subject)}
                >
                  {subject}
                </Checkbox>
              ))}
            </div>
          </Form.Item>

          {refSubject.secondCount > 0 && (
            <Form.Item
              name="bakSubjects"
              label={`${refSubject.title2}（必选${refSubject.secondCount}项）`}
              required
              validateStatus={
                gaokaoStore.selectedBakSubjects.length !==
                refSubject.secondCount
                  ? 'error'
                  : ''
              }
              help={
                gaokaoStore.selectedBakSubjects.length !==
                refSubject.secondCount
                  ? `请选择${refSubject.secondCount}个科目`
                  : ''
              }
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
            >
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(3, 1fr)', // 每行3列
                  gap: 16,
                  alignItems: 'center',
                }}
              >
                {refSubject.zaixuankemu.map((subject, index) => (
                  <Checkbox
                    key={subject}
                    checked={gaokaoStore.isSelectedBakSubject(subject)}
                    onChange={() => toggleBakSubject(subject)}
                  >
                    {subject}
                  </Checkbox>
                ))}
              </div>
            </Form.Item>
          )}

          <Form.Item
            label="报考批次"
            name="pici"
            rules={[{ required: true, message: '请选择报考批次' }]}
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
          >
            <Radio.Group
              value={gaokaoStore.selectedPici || ''}
              options={refPici.map(item => ({
                label: item,
                value: item,
              }))}
              onChange={e => togglePici(e.target.value)}
            />
          </Form.Item>

          <Form.Item
            label="优先"
            name="priority"
            rules={[{ required: true, message: '请选择优先项' }]}
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
          >
            <Radio.Group
              value={gaokaoStore.selectedPriority || ''}
              options={priorityOptions.map(item => ({
                label: item,
                value: item,
              }))}
              onChange={e => togglePriority(e.target.value)}
            />
          </Form.Item>

          <Form.Item
            label="偏好城市"
            name="preferredCity"
            rules={[{ required: false, message: '请选择偏好城市' }]}
          >
            <Select
              placeholder="请选择偏好城市"
              value={gaokaoStore.selectedPreferredCity}
              onChange={value => gaokaoStore.setPreferredCity(value)}
            >
              {gaokaoStore.getHotCities().map(item => (
                <Option key={item} value={item}>
                  {item}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            label="偏好专业"
            name="major"
            rules={[{ required: false, message: '请选择偏好专业' }]}
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
          >
            <div style={{ display: 'flex', gap: 16 }}>
              <Select
                value={gaokaoStore.selectedDiscipline}
                style={{ width: 120 }}
                onChange={value => gaokaoStore.setDiscipline(value)}
                options={[
                  ...disciplineOptions.map(item => ({
                    value: item,
                    label: item,
                  })),
                ]}
              />
              <Select
                value={gaokaoStore.selectedMajor}
                onChange={value => gaokaoStore.toggleMajor(value)}
                options={[
                  ...refMajor.map(item => ({
                    value: item,
                    label: item,
                  })),
                ]}
              />
            </div>
          </Form.Item>

          <Form.Item
            label="毕业意向"
            name="graduation"
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
          >
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(4, 1fr)', // 每行4列
                gap: 16,
                alignItems: 'center',
              }}
            >
              {graduationOptions.map(item => (
                <Checkbox
                  key={item}
                  checked={gaokaoStore.isSelectedGraduation(item)}
                  onChange={() => toggleGraduation(item)}
                >
                  {item}
                </Checkbox>
              ))}
            </div>
          </Form.Item>

          <Form.Item style={{ marginBottom: 4 }}>
            <Button
              style={{ width: '100%' }}
              type="primary"
              htmlType="submit"
              size="large"
              disabled={step != 1}
            >
              提交
            </Button>
          </Form.Item>
        </Form>

        {/* {disable ? null : (
          <Countdown
            planStepId={planStepId}
            disable={step != 2}
            timeout={100}
            overrun={evt => {
              console.log('倒计时结束，自动提交');
              handleSubmit();
            }}
            className="absolute -left-48px -bottom-86px"
          />
        )} */}
      </div>
    );
  };

  return <div className="gaokao">{renderRequiredInfo()}</div>;
};

export default React.memo(observer(GaoKaoParams));
